import { Stack } from '../Layout'
import { Spinner } from '../Loading'
import { Button, type ButtonProps } from './mui'

export interface SubmitButtonProps extends Omit<ButtonProps, 'name'> {
  isLoading: boolean
  loadingText?: string
}

export function SubmitButton({ isLoading, loadingText = '', disabled, children, ...props }: SubmitButtonProps) {
  return (
    <Button disabled={disabled || isLoading} name='intent' {...props}>
      {isLoading ? (
        <Stack direction='row' spacing={2} alignItems='center'>
          <Spinner size={25} />
          {loadingText && <span>{loadingText}</span>}
        </Stack>
      ) : (
        children
      )}
    </Button>
  )
}
